import { render, staticRenderFns } from "./list_attribute_option.vue?vue&type=template&id=1588cac6&scoped=true"
import script from "./list_attribute_option.vue?vue&type=script&lang=js"
export * from "./list_attribute_option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1588cac6",
  null
  
)

export default component.exports